import React, {Component} from "react";
import PropTypes from "prop-types";
import EventItem from "../EventItem/EventItem";

class ListEvents extends Component {




    render() {
        let {events,  onRemove, onUpdate} = this.props;

        return (
            <div className="ListEvents">
                {
                    events.map(event => {
                        return (
                            <EventItem onUpdate={onUpdate} onRemove={onRemove} key={event._id} event={event}/>
                        );
                    })
                }

            </div>
        );
    }
}

ListEvents.propTypes = {
    events: PropTypes.array,
    onRemove: PropTypes.func,
    onUpdate: PropTypes.func,
};

export default ListEvents;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/events/EventsPage/ListEvents.js